import {
  SET_HANDLE_LOGOUT,
  SET_USER_DATA,
  CHANGE_LANGUAGE,
  SUCCESS_LOAD_PERMISSION,
  BLOCK_ACCESS,
  INTERNAL_SERVER_ERROR,
} from 'store/actions/account'
import getStorageLanguage from 'utils/getLang'

const initialState = {
  userName: '',
  name: '',
  handleLogout: null,
  language: getStorageLanguage(),
  roleId: null,
  plantIds: [],
  isLoadedPermission: false,
  hasAccess: true,
  hasServerError: false,
}

const account = (state = initialState, {type, data}) => {
  switch (type) {
    case SET_USER_DATA: {
      const {userName, name} = data
      return {
        ...state,
        userName,
        name,
      }
    }
    case SET_HANDLE_LOGOUT:
      return {
        ...state,
        handleLogout: data,
      }
    case CHANGE_LANGUAGE:
      return {
        ...state,
        language: data,
      }
    case SUCCESS_LOAD_PERMISSION: {
      const {plantIds, roleId} = data
      return {
        ...state,
        plantIds,
        roleId,
        isLoadedPermission: true,
      }
    }
    case BLOCK_ACCESS:
      return {
        ...state,
        hasAccess: false,
        isLoadedPermission: true,
      }
    case INTERNAL_SERVER_ERROR:
      return {
        ...state,
        hasServerError: true,
        isLoadedPermission: true,
      }
    default:
      return state
  }
}

export default account
